// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : Removed the unused 'line' and 'AutoLoan Index'
// MODFIED DATA : 01-08-2025
const PreCloseLoanActionTypes = {
	/*********** FETCH PRE CLOSE LOAN MEMBER REPORT LIST START ************************ */
	FETCH_PRE_CLOSE_LOAN_LIST_START: 'fetch_pre_close_loan_list_start',
	FETCH_PRE_CLOSE_LOAN_LIST_SUCCESS: 'fetch_pre_close_loan_list_success',
	FETCH_PRE_CLOSE_LOAN_LIST_FAILURE: 'fetch_pre_close_loan_list_failure',
	FETCH_PRE_CLOSE_LOAN_LIST_RESPONSE_RESET: 'fetch_pre_close_loan_list_reset',
	FETCH_PRE_CLOSE_LOAN_LIST_RESPONSE_CHANGED: 'fetch_pre_close_loan_list_changed',
	/*********** FETCH PRE CLOSE LOAN MEMBER REPORT LIST END ************************ */

	/*********** UPDATE PRE CLOSE LOAN MEMBER REPORT LIST START ************************ */
	UPDATE_PRE_CLOSE_LOAN_LIST_START: 'update_pre_close_loan_list_start',
	UPDATE_PRE_CLOSE_LOAN_LIST_SUCCESS: 'update_pre_close_loan_list_success',
	UPDATE_PRE_CLOSE_LOAN_LIST_FAILURE: 'update_pre_close_loan_list_failure',
	UPDATE_PRE_CLOSE_LOAN_LIST_RESET: 'update_pre_close_loan_list_reset',
	UPDATE_PRE_CLOSE_LOAN_LIST_CHANGED: 'update_pre_close_loan_list_changed',
	/*********** UPDATE PRE CLOSE LOAN MEMBER REPORT LIST END ************************ */

	/*********** GET BRANCH EOD START ************************ */
	GET_BRANCH_EOD_START: 'get_branch_eod_start',
	GET_BRANCH_EOD_SUCCESS: 'get_branch_eod_success',
	GET_BRANCH_EOD_FAILURE: 'get_branch_eod_failure',
	GET_BRANCH_EOD_RESET: 'get_branch_eod_reset',
	GET_BRANCH_EOD_CHANGED: 'get_branch_eod_changed',
	/*********** GET BRANCH EOD END ************************ */

	/*********** REVERT PRE CLOSE LOAN MEMBER REPORT LIST START ************************ */
	REVERT_PRE_CLOSE_LOAN_LIST_START: 'revert_pre_close_loan_list_start',
	REVERT_PRE_CLOSE_LOAN_LIST_SUCCESS: 'revert_pre_close_loan_list_success',
	REVERT_PRE_CLOSE_LOAN_LIST_FAILURE: 'revert_pre_close_loan_list_failure',
	REVERT_PRE_CLOSE_LOAN_LIST_RESET: 'revert_pre_close_loan_list_reset',
	REVERT_PRE_CLOSE_LOAN_LIST_CHANGED: 'revert_pre_close_loan_list_changed',
	/*********** REVERT PRE CLOSE LOAN MEMBER REPORT LIST END ************************ */
};
export default PreCloseLoanActionTypes;
